import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({ standalone: false,
  selector: 'welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent {

  constructor(private router: Router) { 
  }

  redirectToDashboard() {
    this.router.navigate(['/dashboard']); 
  }
}
